/**
 * @GENERATED from Figma node 3638:52278
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const PackageDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#978F86"
      fillRule="evenodd"
      d="M1 2.277v7.898h1.418v11.548h6.378v-2.13H4.547v-9.416h14.905v9.417h-4.268v2.13h6.398V10.174H23V2.277zm19.71 5.77v-.002h.16V4.406H3.13v3.64h.358v.001z"
      clipRule="evenodd"
    />
    <path
      fill="#978F86"
      d="m16.096 16.369-4.108-4.028-4.085 4.03L9.4 17.887l1.527-1.507v5.342h2.13V16.37l1.55 1.52z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(PackageDark);
export { ForwardRef as PackageDark };
